module.exports = __webpack_public_path__ + "img/minimize.96b5b512.svg";